/* eslint-disable no-alert */
export default class ModalAlert {

  static alert(message) {
    window.alert(message);
  }
}



// WEBPACK FOOTER //
// ./src/ModalAlert.js